<template>
  <div class="status-change-query">
    <MenuTabs v-model="current"
              title="选择异动类型">
      <el-tab-pane v-for="changeType in changeTypes"
                   :key="changeType.code"
                   :name="changeType.code"
                   :label="changeType.name"
                   lazy>
        <div class="query-pane">
          <component :is="changeType.component"
                     :active="changeType.code === current"></component>
        </div>
      </el-tab-pane>
    </MenuTabs>
  </div>
</template>

<script>
import MenuTabs from '../../../../../../widgets/custom/MenuTabs'
import StatusChangeQuery from './all'
import StatusChangeQuerySuspend from './suspend'
import StatusChangeQueryDropout from './dropout'
import StatusChangeQueryDormancy from './dormancy'
import StatusChangeQueryReenter from './reenter'
import StatusChangeQueryRollClass from './roll-class'
import StatusChangeQueryRollState from './roll-state'
import changeType from '../../../../../../../constants/biz/status/changeType'
export default {
  name: 'StatusChangeQuery',
  components: {
    MenuTabs
  },
  data () {
    return {
      changeTypes: [{
        name: '全部',
        code: '9999',
        component: StatusChangeQuery
      }, {
        ...changeType.SUSPEND,
        component: StatusChangeQuerySuspend
      }, {
        ...changeType.DROPOUT,
        component: StatusChangeQueryDropout
      }, {
        ...changeType.DORMANCY,
        component: StatusChangeQueryDormancy
      }, {
        ...changeType.REENTER,
        component: StatusChangeQueryReenter
      }, {
        ...changeType.ROLL_CLASS,
        component: StatusChangeQueryRollClass
      }, {
        ...changeType.ROLL_STATE,
        component: StatusChangeQueryRollState
      }],
      current: ''
    }
  },
  created () {
    this.current = this.changeTypes[0].code
  }
}
</script>

<style lang="scss">
  .status-change-query {
    height: 100%;
    .query-pane {
      height: 100%;
    }
  }
</style>
